const useStyles = () => {
	return {
		containerBtnTranslate: 'w-full flex justify-end mt-[100px] pr-8 ',
	};
};

export default useStyles;
